// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_lc-0";
export var buttonContainer = "_lc-3";
export var cancelButton = "_lc-4";
export var headerSection = "_lc-6";
export var headerTitle = "_lc-9";
export var messageSideLeft = "_lc-1";
export var messageSideRight = "_lc-2";
export var orderNumberContainer = "_lc-7";
export var orderNumberLabel = "_lc-8";
export var submitButton = "_lc-5";